import {
  AdditionalDocCommonApplicantDetails,
  CommonApplicantDetails,
  RudiApplicantDetails,
  SEApplicantDetails,
  ServicesApplicant,
} from "../../types/common/applicantDetailsTypes";
import { initialCompany, initialServicesNaturalPerson, initialUniversity } from "./personInitialValues";
import { ApplicantType } from "../../types/common/personTypes";
import { initialContactAddress, initialReceiverAddress } from "./addressInitialValues";
import { DocumentReceiveMethod, RecognitionKind } from "@duosoftbg/nacid-components";
import { DocumentReceiveOption, DocumentReceiveOptionKind } from "../../utils/constants";

export const initialResultReceive: DocumentReceiveMethod = {
  id: "",
  name: "",
  documentRecipient: false,
  certificateReceiveFormCode: "",
};

export const initialSeReceiveDocumentOption: DocumentReceiveMethod = {
  id: DocumentReceiveOption.NO_SUBMISSION_REQUIRED,
  name: "",
  documentRecipient: false,
};

export const initialServicesApplicant: ServicesApplicant = {
  applicantType: ApplicantType.NATURAL_PERSON,
  naturalPerson: initialServicesNaturalPerson,
  company: initialCompany,
  university: initialUniversity,
};

export const initialCommonApplicantDetails: CommonApplicantDetails = {
  applicant: initialServicesApplicant,
  applicantHasRepresentative: false,
  representative: initialServicesNaturalPerson,
  representativeCapacity: "",
  contactAddress: initialContactAddress,
  resultReceiveElectronic: null,
  resultReceivePaper: null,
  agreeDataUsage: false,
  documentsDeclaration: false,
  applicantTitleAfter: "",
  applicantTitleBefore: "",
  representativeCompanyIdentifier: "",
  certificateReceiveForms: null,
};

export const initialLibApplicantDetails: CommonApplicantDetails = {
  ...initialCommonApplicantDetails,
  agreeDataUsage: null,
  documentsDeclaration: null,
  hasContactAddress: false,
  contactAddress: null,
  resultReceiveElectronic: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  resultReceivePaper: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  certificateReceiveForms: [],
};

export const initialUniChecksApplicantDetails: CommonApplicantDetails = {
  ...initialCommonApplicantDetails,
  resultReceiveElectronic: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  resultReceivePaper: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  certificateReceiveForms: [],
};

export const initialRudiApplicantDetails: RudiApplicantDetails = {
  ...initialCommonApplicantDetails,
  diplomaNamesDifferent: false,
  diplomaNames: {
    firstName: "",
    middleName: "",
    lastName: "",
  },
  resultReceiveElectronic: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  resultReceivePaper: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  certificateReceiveForms: [],
};

export const initialSEApplicantDetails: SEApplicantDetails = {
  ...initialCommonApplicantDetails,
  diplomaNamesDifferent: false,
  diplomaNames: {
    firstName: "",
    middleName: "",
    lastName: "",
  },
  resultReceiveElectronic: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  resultReceivePaper: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  certificateReceiveForms: [],
  applicationKind: "",
  originalDocsReceiveOption: {
    resultReceive: initialSeReceiveDocumentOption,
    receiverAddress: initialReceiverAddress,
    optionKind: { id: DocumentReceiveOptionKind.ORIGINAL_DOCUMENTS_RECEIVE_OPTION, name: "" },
  },
};

export const initialSERecApplicantDetails: SEApplicantDetails = {
  ...initialSEApplicantDetails,
  applicationKind: RecognitionKind.CERTIFICATE,
};

export const initialSEVerLetterApplicantDetails: SEApplicantDetails = {
  ...initialSEApplicantDetails,
  applicationKind: RecognitionKind.VERIFICATION_LETTER,
};

export const initialSEOfficialNoteApplicantDetails: SEApplicantDetails = {
  ...initialSEApplicantDetails,
  applicationKind: RecognitionKind.OFFICIAL_NOTE,
};

export const initialAdditionalDocApplicantDetails: AdditionalDocCommonApplicantDetails = {
  ...initialCommonApplicantDetails,
  diplomaNamesDifferent: false,
  diplomaNames: {
    firstName: "",
    middleName: "",
    lastName: "",
  },
  resultReceiveElectronic: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  resultReceivePaper: { resultReceive: initialResultReceive, receiverAddress: initialReceiverAddress },
  certificateReceiveForms: [],
};
